import React, { useState, useEffect } from "react";
import axios from "axios";
import WeatherInfo from "./WeatherInfo";
import WeatherWeekly from "./WeatherWeekly.js";

export default function Weather(props) {
  const [weatherData, setWeatherData] = useState({ loaded: false });
  const [city, setCity] = useState(props.defaultCity);
  const [searchCity, setSearchCity] = useState(props.defaultCity);

  function displayWeather(response) {
    setWeatherData({
      ready: true,
      cityName: response.data.city,
      temperature: response.data.temperature.current,
      wind: response.data.wind.speed,
      humidity: response.data.temperature.humidity,
      description: response.data.condition.description,
      date: new Date(response.data.time * 1000),
      iconURL: `http://shecodes-assets.s3.amazonaws.com/api/weather/icons/${response.data.condition.icon}.png`,
    });
  }

  // function searchCity() {
  //   let apiKey = "ta8of46b0a3a9f030b9f4d2457bdb911";
  //   let apiURL = `https://api.shecodes.io/weather/v1/current?query=${city}&key=${apiKey}&units=metric`;

  //   // let apiKey = "c819171fe0abdc14039af4ef5dda283b";
  //   // let apiURL = `https://api.openweathermap.org/data/2.5/weather?q=${props.defaultCity}&appid=${apiKey}&units=metric`;
  //   axios.get(apiURL).then(displayWeather);
  // }
  useEffect(() => {
    let apiKey = "ta8of46b0a3a9f030b9f4d2457bdb911";
    let apiURL = `https://api.shecodes.io/weather/v1/current?query=${searchCity}&key=${apiKey}&units=metric`;
    axios.get(apiURL).then(displayWeather);
  }, [searchCity]);

  function handleSubmit(event) {
    event.preventDefault();
    setSearchCity(city);
  }

  function updateCity(event) {
    setCity(event.target.value);
  }

  if (weatherData.ready) {
    return (
      <div>
        <form onSubmit={handleSubmit} className="row g-3" id="findCity">
          <div className="input-group searchBox">
            <input
              type="text"
              className="form-control"
              placeholder="Enter a city"
              id="searchCity"
              onChange={updateCity}
            />
            <button className="btn btn-primary col-3" type="submit">
              Search
            </button>
          </div>
        </form>

        <WeatherInfo data={weatherData} />
        <WeatherWeekly cityForecast={weatherData.cityName} />
      </div>
    );
  } else {
    // searchCity();
    return "Loading...";
  }
}
